import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const StyledLabel = styled("label")({
  marginTop: "auto",
  display: "block",
});

export const HiddenInput = styled("input")({
  display: "none",
});

export const StyledUploadButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  borderRadius: theme.spacing(2),
  fontWeight: 400,
  fontSize: "14px",
  color: "#492A18",
  border: "1px solid transparent",
  boxShadow:
    "-4px -4px 17.8px 0px rgba(173, 183, 194, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)",
  "&:hover": {
    boxShadow:
      "-4px -4px 17.8px 0px rgba(173, 183, 194, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)",
    backgroundColor: "rgba(73,42,24,0.02)",
    borderColor: "rgba(73,42,24, 0.2)",
  },
  height: "55px",
  width: "100%",
  justifyContent: "flex-start",
  fontFamily: "'Quicksand', sans-serif",
}));
